<template>
  <div class="app-container">
    <div class="filter-container">
      <el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
        <el-form-item prop="keyword">
          <el-select v-model="listQuery.type" placeholder="请选择会员卡卡种" clearable @keyup.enter.native="SearchData">
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="keyword">
          <el-input v-model="listQuery.price" placeholder="请输入价格" clearable @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>

    </div>
    <!--动作组-->
    <div class="action-container">
      <el-button-group>
        <!-- 弹窗层编辑 -->
        <el-button v-auth="'MemberCard.create'" class="action-item" type="primary" icon="el-icon-edit" @click="HandleCreate">添加</el-button>
        <el-button v-auth="'MemberCard.delete'" class="action-item" icon="el-icon-delete" @click="BatchDelete">删除</el-button>

      </el-button-group>
    </div>
    <!--表开始-->
    <el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%" @sort-change="sortChange">
      <!--列开始-->
      <el-table-column type="selection"></el-table-column>
      <el-table-column align="center" prop="type_name" label="会员卡卡种 "> </el-table-column>
      <el-table-column align="center" prop="img" label="图片 ">
        <template slot-scope="scope">
          <img v-if="scope.row.img" :src="scope.row.img" width="70" height="50">
        </template>
      </el-table-column>
      <el-table-column align="center" prop="price" label="价格 ">
        <template slot-scope="scope">
          ￥ {{ scope.row.price }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="days" label="有效天数 "></el-table-column>
      <el-table-column align="center" prop="rights_desc" label="权益说明" show-overflow-tooltip> </el-table-column>
      <el-table-column align="center" prop="order_no" label="排序 "> </el-table-column>

      <el-table-column align="center" prop="" label="操作" width="200" class-name="action">
        <template slot-scope="scopes">
          <el-button v-auth="'MemberCard.edit'" type="primary" plain icon="el-icon-edit" size="mini" @click="HandleUpdate(scopes.row)">编辑</el-button>
          <el-button v-auth="'MemberCard.delete'" type="danger" plain icon="el-icon-delete" size="mini" @click="RowDelete(scopes.row)">删除</el-button>

        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="loadData" />
    <!--弹窗编辑/新增窗体-->
    <el-dialog :title="dialogStatus=='create'?'新增':'编辑'" :visible.sync="dialogFormVisible" top="8vh" width="940px">
      <el-form ref="dataForm" :rules="rules" :model="temp" :inline="true" label-position="right" label-width="110px" style="width: 100%;height:65vh;overflow-y:scroll;">
        <el-form-item label="会员卡卡种" prop="type">
          <el-select v-model="temp.type" placeholder="请选择" style="width:300px;">
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item><br>
        <el-form-item label="图片" prop="img">
          <FileList v-model="temp.img" :item-width="140" :item-height="100" :limit="1" type="image" />
        </el-form-item><br>
        <el-form-item label="有效天数" prop="days">
          <el-input-number v-model="temp.days" :step="1" :min="1" placeholder="请输入有效天数" style="width:300px;"></el-input-number>
        </el-form-item>
        <el-form-item label="价格" prop="price">
          <el-input-number v-model="temp.price" :precision="2" :step="0.1" :min="0" placeholder="请输入价格" style="width:300px;"></el-input-number>
        </el-form-item>
        <el-form-item label="约课须知" prop="book_desc">
          <WangEditor v-model="temp.book_desc" :value.sync="temp.book_desc" style="width:720px;" />
        </el-form-item>
        <el-form-item label="用卡须知" prop="use_desc">
          <WangEditor v-model="temp.use_desc" :value.sync="temp.use_desc" style="width:720px;" />
        </el-form-item>
        <el-form-item label="权益说明" prop="rights_desc">
          <WangEditor v-model="temp.rights_desc" :value.sync="temp.rights_desc" style="width:720px;" />
        </el-form-item>
        <el-form-item label="排序" prop="order_no">
          <el-input-number v-model="temp.order_no" :min="0" :step="1" />
          <el-tooltip content="排序的数字越小越靠前" placement="top-start" style="margin-left:10px;">
            <i class="el-icon-question" />
          </el-tooltip>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="ConfirmData">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/card' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
import WangEditor from '@/components/WangEditor'
import FileList from '@/components/attachment/FileList'

export default {
  name: 'MemberCard',
  components: { Pagination, FileList, WangEditor },
  // 列绑定格式化器
  filters: {
  },
  mixins: [commonList],
  data() {
    return {
      // api接口方法
      api,
      // 校验
      rules: {
        type: [{ required: true, message: '请选择会员卡卡种', trigger: ['blur', 'change'] }],
        img: [{ required: true, message: '请上传图片', trigger: ['blur', 'change'] }],
        days: [{ required: true, message: '请输入有效天数', trigger: ['blur', 'change'] }],
        price: [{ required: true, message: '请输入价格', trigger: 'blur' }],
        book_desc: [{ required: true, message: '请输入约课须知', trigger: 'blur' }],
        use_desc: [{ required: true, message: '请输入用卡须知', trigger: 'blur' }],
        rights_desc: [{ required: true, message: '请输入权益说明', trigger: 'blur' }]
      },
      temp: {},
      listQuery: {
        page: 1,
        limit: 10, // 页大小
        order: 'asc', // 默认排序方式,
        sort: 'order_no'
      },
      typeList: []
    }
  },
  // watch: {
  //   'temp.img': {
  //     handler() {
  //       this.$refs.dataForm.validateField('img')
  //     }
  //   }
  // },
  created() {
    this.loadData()
    this.getType()
  },
  methods: {
    // 显示添加窗体
    HandleCreate() {
      this.resetTemp()
      console.log(this.temp, '+++++++++++')
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
      })
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
    },
    // 显示编辑窗体
    HandleUpdate(row) {
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
      })
      this.temp = JSON.parse(JSON.stringify(row)) // copy obj
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
    },
    getType() {
      this.api.TypeList(this.listQuery).then(response => {
        this.typeList = response.data
      })
    },
    resetTemp() {
      this.temp = {
        id: undefined,
        days: '',
        img: '',
        type: '',
        price: '',
        book_desc: '',
        use_desc: '',
        rights_desc: '',
        order_no: 99999
      }
    }

  }
}
</script>
<style scoped>
::-webkit-scrollbar {
    width: 5px;  /* 定义滚动条的宽度 */
}
::-webkit-scrollbar-track {
    background: #ecf5ff; /* 定义轨道的背景颜色 */
}
::-webkit-scrollbar-thumb {
    background: #b3d8ff; /* 定义滑块的背景颜色 */
}
::-webkit-scrollbar-thumb:hover {
    background: #b3d8ff; /* 定义滑块在悬停状态下的背景颜色 */
}
</style>
